module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ee.78f80484.png";